// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { CurrencyAmountV2 } from '@taqueria/protocol/types';
import { CurrencyAmountV2 as CurrencyAmountV2Strict } from '@taqueria/protocol/out/types-strict';
import { currencyAmountV2Schema } from '@taqueria/protocol/out/types-zod';

export type { CurrencyAmountV2Strict as CurrencyAmountV2 };

export const from = (input: unknown): CurrencyAmountV2Strict => {
	try {
		return currencyAmountV2Schema.parse(input) as CurrencyAmountV2Strict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["CurrencyAmountV2 is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a CurrencyAmountV2.")
	}
    
};

export const create = (input: CurrencyAmountV2): CurrencyAmountV2Strict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, CurrencyAmountV2Strict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<CurrencyAmountV2Strict, '__type'>): FutureInstance<TaqError, CurrencyAmountV2Strict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: currencyAmountV2Schema,
	schema: currencyAmountV2Schema.transform(val => val as CurrencyAmountV2Strict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = currencyAmountV2Schema;

export type t = CurrencyAmountV2Strict;
        